import React, { Fragment, useState, useEffect } from "react";
import {
    Button,
    Modal,
} from "react-bootstrap";

import axios from "axios";
import { Progress } from "reactstrap";
import { getInstance } from '../config/token';
import { useHistory, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const SmsReplyPopup = (props) => {
    const history = useHistory()
    const [messageLoading, setMessageLoading] = useState(false);
    const [message, setmessage] = useState("");
    const [file, setFile] = useState("");
    const [filePath, setFilePath] = useState([]);
    const [fileName, setFileName] = useState([]);
    const [loaded, setLoader] = useState(0);
    const prefix = process.env.REACT_APP_API_URL;
    // const [replay, setReplay] = useState(false);

    const createMessage = (type = "reply") => {
        setMessageLoading(true)
        let path1 = window.location.pathname.split("/");
        let smsId1 = parseInt(path1[path1.length - 1]);
        // setErrMsg("")
        let errFlag = false;
        if (message == "") {
            errFlag = true;
            toast.error("Message is required.", {
                position: "top-right",
            });
        } else if (message.length > 20000) {
            errFlag = true;
            toast.error("Message can not be more than 20000 characters.", {
                position: "top-right",
            });
        }

        if (!errFlag) {
            let requestObj = {
                message: message,
                file: filePath,
                threadId: smsId1,
                phone: props.toPhoneNo
            };
            let config = getInstance('POST', `/api/sms_reply`, requestObj);
            axios(config).then((res) => {
                setFileName([]);
                setmessage("");
                setFile("");

                // getSmsDetails();
                if (type == 'reload') {
                    // window.location.reload();
                    props.reloadSmsDetail()
                } else {
                    history.push("/sms-list");
                }

                toast.success("Success", {
                    position: "top-right",
                });
                // setReplay(false);
                props.showReplayModal(false)
                setMessageLoading(false)
            }).catch((err) => {
                setMessageLoading(false)
            });
        } else {
            setMessageLoading(false)
        }
    };

    const onFileChange = (e) => {
        setMessageLoading(true)
        // this.setState({ file: e.target.files[0] },() => {
        var mulFiles = e.target.files;
        if (maxSelectFile(e) && checkFileSize(e)) {
            // setLoading(true);
            setFile(mulFiles);
            const data = new FormData();
            for (var x = 0; x < mulFiles.length; x++) {
                data.append("file", mulFiles[x]);
            }
            // data.append("file", e.target.files[0]);
            let config = getInstance('POST', `/api/upload`, data);

            axios.post(config.url, config.data, {
                headers: config.headers,
                onUploadProgress: (ProgressEvent) => {
                    setLoader((ProgressEvent.loaded / ProgressEvent.total) * 100);
                },
            })
                .then((res) => {
                    // then print response status
                    setLoader(0);
                    // setCameraModal(false);
                    let filePathArray = filePath
                    let fName = fileName
                    for (let i = 0; i < res.data.length; i++) {
                        // setFileName(res.data[i] && res.data[i].filename ? res.data[isNaN].filename : "");
                        let filepath = prefix + "/" + res.data[i].path;
                        filePathArray.push(filepath);
                        // setFilePath(filepath)
                        fName.push(res.data[i].filename)
                    }
                    setFilePath(filePathArray);
                    setFileName(fName)
                    setMessageLoading(false)
                    // setLoading(false);
                })
                .catch((err) => {
                    setMessageLoading(false)
                })
        } else {
            setMessageLoading(false)
        }
    };

    const checkFileSize = (event) => {
        let files = event.target.files;
        let size = 5000000;
        let err = "";
        for (var x = 0; x < files.length; x++) {
            if (files[x].size > size) {
                err += files[x].type + " is too large, please pick a smaller file\n";
            }
        }
        if (err !== "") {
            event.target.value = null;
            toast.error(err, {
                position: "top-right",
            });
            return false;
        }

        return true;
    };

    const maxSelectFile = (event) => {
        let files = event.target.files; // create file object
        if (files.length > 3) {
            //  const msg = 'Only 3 images can be uploaded at a time'
            event.target.value = null; // discard selected file
            toast.error("Only 2 files can be uploaded at a time.", {
                position: "top-right",
            });
            return false;
        }
        return true;
    };


    return (
        <Fragment>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Modal
                disabled={messageLoading}
                enforceFocus={false}
                show={props.replayPopupShow}
                // onHide={() => this.setState({ cameraModal: false })}
                className="modal fade"
                id="replay"
            >
                <div className="modal-header">
                    <h5 className="modal-title">SMS Reply</h5>
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        onClick={() => props.showReplayModal(false)}
                    >
                        <span>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <form
                    >
                        <label className="text-black font-w500">
                            Message
                        </label>
                        <textarea
                            name="message"
                            id="textarea"
                            cols={30}
                            rows={5}
                            maxLength={1500}
                            className="form-control form-border-color"
                            // placeholder="Please enter ticket message"
                            defaultValue={""}
                            required
                            // spellcheck="true"
                            //   value={message}
                            onChange={(e) => setmessage(e.target.value)}
                        />
                        <div className="modal-body">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        Upload
                                    </span>
                                </div>
                                <div className="custom-file">
                                    <input
                                        type="file"
                                        name="file"
                                        multiple
                                        className="custom-file-input"
                                        onChange={(e) => onFileChange(e)}
                                    />
                                    <label className="custom-file-label form-border-color">
                                        Choose file
                                    </label>
                                </div>
                            </div>
                            <div class="form-group ">
                                <Progress
                                    max="100"
                                    color="success"
                                    value={loaded}
                                >
                                    {Math.round(loaded, 2)}%
                                </Progress>
                            </div>
                            {fileName.map(function (name, j) {
                                return (
                                    <div>
                                        {name}
                                        <br />
                                    </div>
                                );
                            })}
                        </div>
                    </form>
                </div>
                <div className="modal-footer">

                    <button
                        disabled={messageLoading}
                        type="button"
                        className="btn btn-primary"
                        // style={}
                        onClick={() => createMessage("reload")}
                    >
                        Reply & Reload
                    </button>
                    <button
                        disabled={messageLoading}
                        type="button"
                        className="btn btn-primary"
                        onClick={() => createMessage()}
                    >
                        Reply
                    </button>
                </div>
            </Modal>
        </Fragment>
    )
}

export default SmsReplyPopup;